import { render, staticRenderFns } from "./index.vue?vue&type=template&id=cb060682&scoped=true&"
import script from "./index.vue?vue&type=script&lang=ts&"
export * from "./index.vue?vue&type=script&lang=ts&"
import style0 from "./index.vue?vue&type=style&index=0&id=cb060682&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../16/node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "cb060682",
  null
  
)

export default component.exports